<template>
<div class="list-list">
  <div class="row align-items-center list-header-row">
    <div class="col-md-6 text-left">
      <slot name="header"></slot>
    </div>
    <div class="col-md-6 d-flex align-items-center">
      <div class="input-group mr-2 my-0">
        <div class="input-group-prepend">
          <div class="input-group-text p-1">
            <i class="ion ion-md-search"></i>
          </div>
        </div>
        <input type="text" placeholder="Search Lists" class="form-control p-1 h-100" v-model="search">
      </div>
      <base-dropdown position="right" tag="div">
        <button slot="title" class="btn btn-sm btn-primary btn-simple "><i class="tim-icons icon-minimal-down"></i> Sort{{ sort?`: ${sort_keys[sort]}`:'' }} <i :class="{'fa fa-long-arrow-alt-up': sort_dir === 'asc', 'fa fa-long-arrow-alt-down': sort_dir === 'desc'}"></i></button>
        <div>
          <a href="#" @click.prevent="setSort('name')" class="dropdown-item"><i :class="{'fa fa-check': sort === 'name', 'fa fa-fw': sort !== 'name'}"></i>Sort by Name</a>
          <a href="#" @click.prevent="setSort('content_type')" class="dropdown-item"><i :class="{'fa fa-check': sort === 'content_type', 'fa fa-fw': sort !== 'content_type'}"></i>Sort by Type</a>
          <a href="#" @click.prevent="setSort('created_at')" class="dropdown-item"><i :class="{'fa fa-check': sort === 'created_at', 'fa fa-fw': sort !== 'created_at'}"></i>Sort by Created</a>
          <a href="#" @click.prevent="setSort('last_item_added')" class="dropdown-item"><i :class="{'fa fa-check': sort === 'last_item_added', 'fa fa-fw': sort !== 'last_item_added'}"></i>Sort by Updated</a>
        </div>
      </base-dropdown>
    </div>
  </div>
  <template v-if="sort !== 'content_type'">
    <list-link v-for="list in orderedLists" :key="list.id" :list="list"></list-link>
  </template>
  <template v-else>
    <div v-for="(lists, content_type) in orderedLists" :key="content_type">
      <h4 class="mt-4 text-left text-muted">{{ content_type_names[content_type] }}</h4>
      <list-link v-for="list in lists" :key="list.id" :list="list"></list-link>
    </div>
  </template>
</div>
</template>

<script>
import _ from 'lodash'

import BaseDropdown from '@/components/BaseDropdown'
import ListLink from '@/components/ListLink'
import constants from '@/constants'

export default {
  name: 'ListList',
  props: {
    lists: Array
  },
  components: {
    ListLink,
    BaseDropdown,
  },
  data () {
    return {
      content_type_names: constants.content_type_names,
      search: '',
      sort: 'content_type',
      sort_dir: 'asc',
      sort_keys: {
        name: 'Name',
        content_type: 'Type',
        created_at: 'Created',
        last_item_added: 'Updated'
      }
    }
  },
  computed: {
    orderedLists () {
      let lists = _.orderBy(this.lists, [this.sort], [this.sort_dir])
      if (this.search.length > 2) {
        lists = lists.filter(i => i.name.toLowerCase().includes(this.search.toLowerCase()))
      }
      if (this.sort === 'content_type') {
        return  _.groupBy(lists, 'content_type')
      }
      return lists
    }
  },
  methods: {
    setSort (key) {
      if (this.sort === key) {
        this.sort_dir = this.sort_dir === 'asc'?'desc':'asc'
      } else {
        this.sort = key
      }
    }
  }
}
</script>

<style lang="scss">
.btn.btn-primary.btn-simple, .input-group-text, .form-control {
  background-color: #1f1f21 !important;
  &:hover, &:active, &:focus {
    background-color: #1f1f21 !important;
  }
}
</style>